import React from "react";
import {connect} from "react-redux";
import StryktipsetEditForm from "./TicketLayouts/Stryktipset/StryktipsetEditForm";
import EuropatipsetEditForm from "./TicketLayouts/Europatipset/EuropatipsetEditForm";
import V75EditForm from "./TicketLayouts/V75/V75EditForm";
import V86EditForm from "./TicketLayouts/V86/V86EditForm";

const betItems = [
  {id: "stryktipset", name: "Stryktipset"},
  {id: "europatipset", name: "Europatipset"},
  {id: "v75", name: "V75"},
  {id: "v86", name: "V86"}
];

class VirtualSlipEditFormBase extends React.Component {
  componentDidMount() {
    if (this.props.configuration && this.props.configuration.virtualslips) {
      const {history} = this.props;
      if (this.props.configuration.virtualslips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.virtualslips.enabled !== true)
        history.replace(`/`);
    }
  }

  render() {
    const props = {...this.props};
    const record = {...props.record};
    const selectInputState = record.type;

    switch (selectInputState) {
      case "stryktipset":
        return <StryktipsetEditForm {...props} betItems={betItems} />;

      case "europatipset":
        return <EuropatipsetEditForm {...props} betItems={betItems} />;

      case "v75":
        return <V75EditForm {...props} betItems={betItems} />;

      case "v86":
        return <V86EditForm {...props} betItems={betItems} />;

      default:
        return <StryktipsetEditForm {...props} betItems={betItems} />;
    }
  }
}

const VirtualSlipEditForm = connect((state, props) => ({
  id: decodeURIComponent(props.match.params.id),
  configuration: state.configuration,
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null
}))(VirtualSlipEditFormBase);

export default VirtualSlipEditForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/VirtualSlipEditForm.js